/**
 * A held (parked) cart as the store keeps it — moved out of lib/store.tsx in
 * 1.58 so it can be tested. 178 adds its customer (a held cart and a kept quote
 * come back with their customer, so the group price comes back too) and the
 * kept quote's own terms (lib/quote.ts). A 1.57 row has neither.
 */
import type { HeldCart, HeldCartItem, QuoteSnapshot } from './mock-data'

const num = (v: unknown) => (v == null ? 0 : Number(v))

export function mapHeldCart(r: any): HeldCart {
  return {
    id: r.id,
    label: r.label ?? null,
    items: Array.isArray(r.items) ? (r.items as HeldCartItem[]) : [],
    discount: num(r.discount),
    discount_type: r.discount_type ?? null,
    discount_value: num(r.discount_value),
    total: num(r.total),
    items_count: num(r.items_count),
    customer_id: r.customer_id ?? null,
    quote: r.quote && typeof r.quote === 'object' && !Array.isArray(r.quote) ? (r.quote as QuoteSnapshot) : null,
    created_at: r.created_at,
  }
}

/**
 * The customer a resumed cart comes back with: EXACTLY its own, or none — a walk-in cart, or
 * one whose customer was deleted since, never keeps the customer of the cart on screen, whose
 * group would price it (181, Codex's final review of 1.58, I5).
 */
export function resumeCustomerId(cart: Pick<HeldCart, 'customer_id'>, customers: readonly { id: string }[]): string {
  return cart.customer_id && customers.some((c) => c.id === cart.customer_id) ? cart.customer_id : ''
}
